<template>
  <section class="p-8 max-w-[650px] text-center">
    <h2 class="truncate text-3xl font-semi-bold">{{ activeCampaignAttributes?.title }}</h2>

    <Markdown
      class="mt-3 campaign-markdown"
      data-testid="viewer-campaignModal-body"
      :source="activeCampaignAttributes?.body"
      :linkify="true"
      :typographer="true"
      :breaks="true"
    />

    <div class="mt-8 flex gap-8">
      <div
        v-for="(listItem, idx) in activeCampaignAttributes?.listItems"
        :key="idx"
        class="flex flex-1 gap-4 justify-center items-center"
        :class="activeCampaignAttributes?.listItems.length > 1 ? 'flex-col' : ''"
      >
        <img class="object-fill w-12 h-12" :src="listItem.imageUrl" />
        <span class="text-xl">{{ listItem.text }}</span>
      </div>
    </div>

    <div class="flex justify-center mt-8">
      <Button type="solid" :variant="getCTAType(activeCampaignAttributes)" @click.stop.prevent="followLink" data-testid="viewer-modal-campaignModalCTA">
        <span class="px-6">{{ activeCampaignAttributes?.actionText }}</span></Button
      >
    </div>
  </section>
</template>
<script setup lang="ts">
import Markdown from 'vue3-markdown-it';
import { storeToRefs } from 'pinia';

import { Button } from '@/storybook/button';
import { useCampaignModalsStore, CampaignModalAttributes, CampaignModalType } from '@/store/useCampaignModalsStore';

const campaignModalsStore = useCampaignModalsStore();
const { activeCampaignAttributes } = storeToRefs(campaignModalsStore);

const getCTAType = (activeCampaignAttributes: CampaignModalAttributes) =>
  activeCampaignAttributes?.modalType === CampaignModalType.GENERIC ? 'blue' : 'orange';

const emit = defineEmits(['close']);
const followLink = () => {
  emit('close');
  window.open(activeCampaignAttributes.value.actionLink, '_blank');
};
</script>

<style lang="scss">
// vue3-markdown can't do scoped
.campaign-markdown {
  strong {
    @apply text-orange-500;
  }
}
</style>
